import React, { useEffect } from 'react';
import { Alert, Typography } from '@mui/material';

interface ErrorAlertProps {
    message: string;
    onClose: () => void;
    autoCloseDuration?: number;
}

const ErrorAlert: React.FC<ErrorAlertProps> = ({ message, onClose, autoCloseDuration = 10000 }) => {
    useEffect(() => {
        if (autoCloseDuration) {
            const timer = setTimeout(onClose, autoCloseDuration);
            return () => clearTimeout(timer);
        }
    }, [onClose, autoCloseDuration]);

    // Проверяем, содержит ли сообщение HTML теги
    const containsHtml = /<[a-z][\s\S]*>/i.test(message);

    return (
        <Alert
            severity="error"
            onClose={onClose}
            sx={{ mb: 2, '& a': { color: 'inherit', textDecoration: 'underline' } }}
        >
            {containsHtml ? (
                <Typography
                    component="div"
                    variant="body2"
                    dangerouslySetInnerHTML={{ __html: message }}
                />
            ) : (
                // Split the message by semicolons and render each line separately
                message.split(';').map((line, index) => (
                    <div key={index}>{line}</div>
                ))
            )}
        </Alert>
    );
};

export default ErrorAlert;
